import { useSearchParams as useRouterSearchParams } from 'react-router-dom';

export default function useSearchParams() {
  const [searchParams, setSearchParams] = useRouterSearchParams();

  return [searchParams, setSearchParams];
}
